import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../api";
import { useAuth } from "../context/AuthContext";
import { useRef } from "react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, setTenant, setEmployee } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    (async () => {
      try {
        const r = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        setUser(r.data.user);
        setTenant(r.data.tenant);
        setEmployee(r.data.employee);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: r.data.user } });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser, setTenant, setEmployee]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-blue-700 border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-sm text-slate-500">Signing you in...</p>
      </div>
    </div>
  );
}
